/* eslint-disable @typescript-eslint/ban-types */
import { TranslationsKey } from 'sofa-reborn-react';
import { UrlService } from '.';

let localeTranslations: { [key: string]: string } | null = null;
let localeApplicationSettings: { [key: string]: string } | null = null;
let localeLocalizationSettings: { [key: string]: string } | null = null;
let localeUrls: { [key: string]: string } | null = null;
let countryCode: string | null = null;
let languageCode: string | null = null;

const localeService = {
	getLocale: (): string => {
		let formattedLocale = '';
		const locationSearch = UrlService.getSearchString();
		const params = new URLSearchParams(locationSearch);
		let locale = params.get('locale');

		if (locale) {
			locale = locale.replace('_', '-');
			languageCode = locale.substring(0, 3);
			countryCode = locale.slice(3);
			formattedLocale = languageCode.toLowerCase() + countryCode.toUpperCase();
		} else {
			formattedLocale = 'en-SE';
		}

		return formattedLocale;
	},
	getUrlWithNewLocale: (url: string, locale: string): string => {
		const appUrl = new URL(url);
		appUrl.searchParams.set('locale', locale);
		return appUrl.toString().replace('%2C', ',');
	},
	setTranslations: (
		translations: {},
		appSettings: {},
		localizationSettings: {},
		urls: {}
	): void => {
		localeTranslations = translations;
		localeApplicationSettings = appSettings;
		localeLocalizationSettings = localizationSettings;
		localeUrls = urls;
	},
	getTranslation: (translationKey: TranslationsKey): string => {
		return localeTranslations ? localeTranslations[translationKey] : translationKey;
	},
	getUrl: (urlKey: string): string => {
		return localeUrls ? localeUrls[urlKey] : urlKey;
	},
	getCountryCode: (): string => {
		return countryCode ? countryCode.toLowerCase() : 'se';
	},
	getLanguageCode: (): string => {
		return languageCode ? languageCode.substring(0, 2).toLowerCase() : 'en';
	},
	getApplicationSetting: (flag: string): boolean | string | null => {
		return localeApplicationSettings ? localeApplicationSettings[flag] : null;
	},
	getLocalizationSetting: (setting: string): string | null => {
		return localeLocalizationSettings ? localeLocalizationSettings[setting] : null;
	},
};
export default localeService;
